import type { MessageDescriptor } from 'react-intl';
import type { OutreachReplyLabel } from 'fym-shared/src/music24/outreach/types';
import { inboxMessages as m } from './inboxMessages';

/** The reply labels in menu order (prompt P6, spec §4.6). */
export const REPLY_LABELS: readonly OutreachReplyLabel[] = [
  'interested',
  'placed',
  'later',
  'notAFit',
  'asksForPayment',
  'outOfOffice',
  'unsubscribe',
  'bounce',
  'other',
];

export const REPLY_LABEL_TEXT: Record<OutreachReplyLabel, MessageDescriptor> = {
  interested: m.labelInterested,
  placed: m.labelPlaced,
  notAFit: m.labelNotAFit,
  asksForPayment: m.labelAsksForPayment,
  later: m.labelLater,
  outOfOffice: m.labelOutOfOffice,
  unsubscribe: m.labelUnsubscribe,
  bounce: m.labelBounce,
  other: m.labelOther,
};

/** The chip tone of a label: brand for a chance, green for a placement, amber for payment. */
export function labelTone(label: OutreachReplyLabel): 'vio' | 'pos' | 'warn' | 'muted' {
  if (label === 'interested' || label === 'later') {
    return 'vio';
  }
  if (label === 'placed') {
    return 'pos';
  }
  return label === 'asksForPayment' ? 'warn' : 'muted';
}

/** The labels that wait for the person ("Needs you", design g1 note). */
export function needsAnswer(label: OutreachReplyLabel): boolean {
  return label === 'interested' || label === 'later' || label === 'other';
}
